(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["recensioni-clienti"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-tp-dir]');
    if (!btn) return;
    var track = btn.closest('.tp-slider').querySelector('.tp-track');
    var card = track.querySelector('.tp-card');
    var step = card ? card.offsetWidth + 20 : 300;
    track.scrollBy({ left: step * Number(btn.dataset.tpDir), behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();
})();
